import React, { forwardRef, useCallback } from 'react';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// MAIN COMPONENT
export const nameFormat = Component =>
  forwardRef(({ ...props }, ref) => {
    // PROPS
    const {
      name, //
      onBlur,
      schema,
      type,
      form: { setFieldValue } = {}
    } = props;

    // CALLBACKS
    const titleCase = useCallback(str => {
      if (!str) return str;
      return str
        .split(' ')
        .filter(s => !!s)
        .map(s => {
          let result = s[0].toUpperCase();
          if (s.length > 1) result += s.substring(1).toLowerCase();
          return result;
        })
        .join(' ');
    }, []);

    // RENDER
    return (
      <Component
        {...props} //
        onBlur={e => {
          if ([schema, type].includes('name')) {
            setFieldValue(name, titleCase(e.target.value));
          }
          doCallback(onBlur, e);
        }}
        ref={ref}
      />
    );
  });
